import Modal from "react-bootstrap/Modal";

function DeclarationModal({showModal, setShowModal}) {
    return (
        <Modal size={"lg"} centered={true} show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title className={"annoucement-modal-title"}>Declaration</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>For share applications, you must make the following declaration:</h4>
                <ul>
                    <li>I have attained 18 years of age at the closing date of the share application.</li>
                    <li>I am a Malaysian citizen residing in Malaysia.</li>
                    <li>This application is the only application that I am submitting.</li>
                    <li>I hereby give consent to TA Securities Holdings Berhad and Bursa Malaysia Depository Sdn Bhd to
                        disclose information pertaining to myself and my account with TA Securities Holdings Berhad or
                        Bursa Malaysia Depository Sdn Bhd to the Issuing House and other relevant authorities.
                    </li>
                    <li>This application is submitted using my own CDS Account.</li>
                    <li>I accept that the closing time is determined by the Issuer, the Offeror (where relevant) and the
                        Managing Underwriter/Underwriter (where relevant) and TA Securities Holdings Berhad reserves the
                        right to reject applications submitted after closing time.
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default DeclarationModal;
